<template>
  <div class="PromoHeader">
    <div class="PromoHeader-container PageContainer">
      <Tag
        class="PromoHeader-tag"
        status="accent"
        size="lg">
        {{ t('custom.landing.promo.header.tag') }}
      </Tag>

      <div class="PromoHeader-content">
        <h5 class="PromoHeader-title">{{ t('custom.landing.promo.header.title') }}</h5>
        <p class="PromoHeader-description">{{ t('custom.landing.promo.header.description') }}</p>
      </div>

      <ActionButton
        class="PromoHeader-button"
        size="lg"
        variant="secondary"
        @click="handlePromoClick"
      >
        {{ t('custom.landing.promo.header.button') }}
      </ActionButton>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
const localePath = useLocalePath();

function handlePromoClick() {
  navigateTo(localePath('/plans'));
}
</script>